<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết chấm công bổ sung/ Nghỉ phép</h1>
      <div class="" style="float: right">
        <button
          v-if="
            dataDetail.status === 'WAITING' &&
            dataPermission &&
            dataPermission.includes('CNPS_ATTN_ADD_APPROVE_REJECT')
          "
          class="btn btn-primary ml-2"
          @click="approvedTimekeeping"
        >
          Duyệt
        </button>
        <button
          v-if="
            dataDetail.status === 'WAITING' &&
            dataPermission &&
            dataPermission.includes('CNPS_ATTN_ADD_APPROVE_REJECT')
          "
          class="btn btn-danger ml-2"
          data-toggle="modal"
          @click="showModalRefuse"
        >
          Từ chối
        </button>
        <button
          v-if="
            dataDetail.status === 'APRROVED' &&
            dataPermission &&
            dataPermission.includes('CNPS_ATTN_ADD_ACCEPT')
          "
          class="btn btn-primary ml-2"
          @click="acceptTimekeeping"
        >
          Xác nhận
        </button>
        <button
          v-if="
            dataDetail.status === 'APRROVED' &&
            dataPermission &&
            dataPermission.includes('CNPS_ATTN_ADD_ACCEPT')
          "
          class="btn btn-danger ml-2"
          data-toggle="modal"
          @click="showModalNotAccept"
        >
          Không xác nhận
        </button>
        <button @click="$router.push('/timekeeping')" class="btn btn-outline-secondary ml-2">
          Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-6 mb-3">
          <div class="form-detail">
            <h1>Thông tin chấm công bổ sung/ nghỉ phép</h1>
            <!-- <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Người tạo<span class="float-right">:</span></label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">1221</p>
                </div>
              </div> -->
            <div
              class="form-group form-row"
              v-if="
                (dataDetail.type === 'ATTN_ADD' &&
                  !typeCheckInOut.includes(dataDetail.reasonAttnAdd)) ||
                dataDetail.type !== 'ATTN_ADD'
              "
            >
              <label for="" class="col-sm-4 col-form-label"
                >Đăng ký nghỉ nhiều ngày<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <div class="checkbox">
                  <input
                    class="inp-cbx"
                    id="cbx01"
                    :checked="dataDetail.isMultiDay"
                    :disabled="true"
                    type="checkbox"
                    style="display: none"
                  />
                  <label class="cbx" for="cbx01">
                    <span>
                      <svg width="12px" height="10px" viewBox="0 0 12 10">
                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                      </svg>
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Kiểu<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ dataDetail.typeString }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="dataDetail.reasonString">
              <label for="" class="col-sm-4 col-form-label"
                >Loại<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ dataDetail.reasonString }}</p>
              </div>
            </div>
            <div
              class="form-group form-row"
              v-if="
                dataDetail.type === 'ATTN_ADD' && typeCheckInOut.includes(dataDetail.reasonAttnAdd)
              "
            >
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ dataDetail.startDate | formatDate }}</p>
              </div>
            </div>
            <div v-else>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Bắt đầu<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail.startDate | formatDate('HH:mm:ss DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Kết thúc<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ dataDetail.endDate | formatDate('HH:mm:ss DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <span v-if="dataDetail.status === 'NEW'" class="badge badge-success"
                    >Mới tạo</span
                  >
                  <span v-if="dataDetail.status === 'DENIED'" class="badge badge-danger"
                    >Đã hủy</span
                  >
                  <span v-if="dataDetail.status === 'WAITING'" class="badge badge-warning"
                    >Chờ duyệt</span
                  >
                  <span v-if="dataDetail.status === 'APRROVED'" class="badge badge-primary"
                    >Đã duyệt</span
                  >
                  <span v-if="dataDetail.status === 'ACCEPT'" class="badge badge-primary"
                    >Xác nhận</span
                  >
                  <span v-if="dataDetail.status === 'NOT_ACCEPT'" class="badge badge-danger"
                    >Không xác nhận</span
                  >
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Ghi chú<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ dataDetail.note }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian tạo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ dataDetail.createdDate | formatDate('HH:mm:ss DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="dataDetail.approveOrRejectDate">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian duyệt/ từ chối<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ dataDetail.approveOrRejectDate | formatDate('HH:mm:ss DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="dataDetail.acceptOrRejectDate">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian xác nhận/ không xác nhận<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ dataDetail.acceptOrRejectDate | formatDate('HH:mm:ss DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="timekeepingInfo.approveName">
              <label for="" class="col-sm-4 col-form-label"
                >Người duyệt/từ chối<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ timekeepingInfo.approveName }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="timekeepingInfo.acceptName">
              <label for="" class="col-sm-4 col-form-label"
                >Người xác nhận/không xác nhận<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ timekeepingInfo.acceptName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Lý do<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12" v-if="dataDetail.reasonReject">
                  {{ dataDetail.reasonReject }}
                </p>
                <p class="form-control-plaintext f12" v-if="dataDetail.reasonNotAccept">
                  {{ dataDetail.reasonNotAccept }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-detail">
            <h1>Thông tin nhân viên</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Nhân viên <span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ staffInfo.name }}</p>
              </div>
            </div>
            <!-- <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label">Công ty<span class="float-right">:</span></label>
                  <div class="col-sm-8">
                      <p class="form-control-plaintext f12">sadasdasd ád</p>
                  </div>
              </div> -->
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Quản lý<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ staffInfo.superiorName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Vị trí<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ staffInfo.typeSale | transformData(listTypeSale) }}
                </p>
              </div>
            </div>
          </div>
          <div class="img-list-wrapper" v-if="dataDetail.imageUrl">
            <h1 class="form-inner-heading">Ảnh đính kèm</h1>
            <div class="form-group row img-list mr-0 ml-0">
              <ul v-viewer>
                <li v-for="(item, index) in dataDetail.imageUrl" :key="index">
                  <a href="#" data-toggle="modal" id="attach-img">
                    <img :src="item" class="image-detail" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Modal thông báo-->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" alt="icon-successs" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <!--Modal từ chối-->
    <b-modal id="modal-scoped" v-model="refuseModal">
      <template #modal-header="{ close }">
        <h5>Lý do từ chối</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <textarea v-model="textReason" class="form-control" :maxlength="225" rows="3"></textarea>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
        <b-button size="sm" variant="primary" @click="refuseTimekeeping()"> Xác nhận </b-button>
      </template>
    </b-modal>
    <!--Modal không xác nhận-->
    <b-modal id="modal-scoped" v-model="notAcceptModal">
      <template #modal-header="{ close }">
        <h5>Lý do từ chối</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <textarea v-model="textReason2" class="form-control" :maxlength="225" rows="3"></textarea>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
        <b-button size="sm" variant="primary" @click="notAcceptTimekeeping()"> Xác nhận </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { AttentdentService } from '@/services/attentdent.service'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'

  export default {
    data() {
      return {
        userData: JSON.parse(localStorage.getItem('userData')),
        id: this.$route.params.id,
        dataDetail: {},
        timekeepingInfo: {},
        staffInfo: {},
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        refuseModal: false,
        textReason: '',
        notAcceptModal: false,
        textReason2: '',
        typeCheckInOut: ['FORGOT_ATTN_IN', 'FORGOT_ATTN_OUT'],
        listTypeSale: Config.listTypeSale,
      }
    },
    mounted() {
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      // duyệt, từ chối
      async ApprovedOrReject(params) {
        try {
          const data = await AttentdentService.timekeepingApporovedOrReject(params)
          if (data.success) {
            this.refuseModal = false
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = data.message
            this.notiModal = true
            this.fetchData()
          } else {
            this.refuseModal = false
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = data.message
            this.notiModal = true
          }
        } catch (error) {}
      },
      // duyệt
      approvedTimekeeping() {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: `Bạn chắc chắn duyệt <b>${this.dataDetail.reasonString ?? this.dataDetail.typeString}</b> của nhân viên <b>${this.staffInfo.name}</b>`,
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Duyệt chấm công',
            okTitle: 'Duyệt',
            cancelTitle: 'Bỏ qua',
            centered: true,
          })
          .then(value => {
            if (value) {
              this.ApprovedOrReject({
                isApprove: true,
                lstAttnId: [this.id],
                reason: '',
                superior: this.userData.username,
              })
            }
          })
      },
      // từ chối
      showModalRefuse() {
        this.refuseModal = true
      },
      refuseTimekeeping() {
        this.ApprovedOrReject({
          isApprove: false,
          lstAttnId: [this.id],
          reason: this.textReason,
          superior: this.userData.username,
        })
      },
      // xác nhận, không xác nhận
      async AcceptOrNotAccept(params) {
        try {
          const data = await AttentdentService.timekeepingAcceptOrNotAccept(params)
          if (data.success) {
            this.notAcceptModal = false
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = data.message
            this.notiModal = true
            this.fetchData()
          } else {
            this.notAcceptModal = false
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = data.message
            this.notiModal = true
          }
        } catch (error) {}
      },
      // xác nhận
      acceptTimekeeping() {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: `Bạn chắc chắn xác nhận <b>${this.dataDetail.reasonString ?? this.dataDetail.typeString}</b> của nhân viên <b>${this.staffInfo.name}</b>`,
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Xác nhận',
            okTitle: 'Xác nhận',
            cancelTitle: 'Bỏ qua',
            centered: true,
          })
          .then(value => {
            if (value) {
              this.AcceptOrNotAccept({
                isApprove: true,
                lstAttnId: [this.id],
                reason: '',
                superior: this.userData.username,
              })
            }
          })
      },
      // không xác nhận
      showModalNotAccept() {
        this.notAcceptModal = true
      },
      notAcceptTimekeeping() {
        this.AcceptOrNotAccept({
          isApprove: false,
          lstAttnId: [this.id],
          reason: this.textReason2,
          superior: this.userData.username,
        })
      },
      // dữ liệu chung
      async fetchData() {
        try {
          const data = await AttentdentService.timekeepingDetail({
            id: this.id,
          })
          if (data.success) {
            this.dataDetail = data.data
            this.staffInfo = {
              name: this.dataDetail.staffInfo.name,
              superiorName: this.dataDetail.staffInfo.superiorName,
              typeSale: this.dataDetail.staffInfo.typeSale,
            }
            this.timekeepingInfo = {
              approveName: this.dataDetail.approveInfo.name,
              acceptName: this.dataDetail.acceptInfo.name,
            }
          }
        } catch (e) {}
      },
    },
  }
</script>
<style scoped>
  .img-list li {
    width: 160px;
    height: 160px;
  }
  .image-detail {
    width: 160px;
    height: 160px;
  }
</style>
